<template>
	<div v-if="show" class="tb-price-disclaimer">Indicative model and pricing only. Due to extended wait times, the final vehicle we can offer you and its price are likely to&nbsp;be&nbsp;different.</div>
</template>
<script>
	import Vue from 'vue';

	export default Vue.extend({
		name: 'PriceDisclaimer', 
		props: ['show']
	});
</script>